import { render, staticRenderFns } from "./branchleague.vue?vue&type=template&id=a1cf2f94&scoped=true&"
import script from "./branchleague.vue?vue&type=script&lang=js&"
export * from "./branchleague.vue?vue&type=script&lang=js&"
import style0 from "./branchleague.vue?vue&type=style&index=0&id=a1cf2f94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cf2f94",
  null
  
)

export default component.exports